import request from '@/utils/request'
import { getShopId } from '@/api/shop/shopApi'

/**
 * 获取支付配置列表
 * @param {Object} params 请求参数
 * @returns {Promise} Promise对象
 */
export function listPaymentPool(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/payment.listPaymentPool',
      method: 'get',
      params: {
        ...params,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 获取支付适配类型
 * @param {Object} params 请求参数
 * @returns {Promise} Promise对象
 */
export function listPaymentAdapt(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/payment.listPaymentAdapt',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 获取支付密钥
 * @param {Object} params 请求参数
 * @returns {Promise} Promise对象
 */
export function listPaymentKey(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/payment.listPaymentKey',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 添加支付配置
 * @param {Object} data 请求数据
 * @returns {Promise} Promise对象
 */
export function savePaymentPool(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/payment.savePaymentPool',
      method: 'post',
      data: {
        ...data,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 更新支付配置
 * @param {Object} data 请求数据
 * @returns {Promise} Promise对象
 */
export function updatePaymentPool(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/payment.updatePaymentPool',
      method: 'post',
      data: {
        ...data,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除支付配置
 * @param {Object} data 请求数据
 * @returns {Promise} Promise对象
 */
export function deletePaymentPool(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/payment.deletePaymentPool',
      method: 'post',
      data: {
        ...data,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 上传文件
 * @param {Object} data 请求数据
 * @param {Object} config 配置项
 * @returns {Promise} Promise对象
 */
export function uploadFile(data, config) {
  return new Promise((resolve, reject) => {
    request({
      url: '/upload/uploadFile',
      method: 'post',
      data,
      onUploadProgress: config.onUploadProgress,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}